export enum ENOPCaseStatus {
  Accepted = 'Accepted',
  AtDonorHospital = 'AtDonorHospital',
  AtTXCenter = 'AtTXCenter',
  ClinicalScreening = 'ClinicalScreening',
  Closed = 'Closed',
  Declined = 'Declined',
  Deleted = 'Deleted',
  DeployedToTXCenter = 'DeployedToTXCenter', // In Transit to TX Center
  Draft = 'Draft',
  Finished = 'Finished',
  New = 'New',
  None = 'None',
  OrganOffOCS = 'OrganOffOCS',
  OrganOnOCS = 'OrganOnOCS',
  OrTimeConfirmed = 'OrTimeConfirmed',
  PendingLogistics = 'PendingLogistics',
  ResourceDeployed = 'ResourceDeployed',
  ResourcesBooked = 'ResourcesBooked',
  ReturningToBase = 'ReturningToBase',
  ServiceCompleted = 'ServiceCompleted',
  ServiceDeclined = 'ServiceDeclined',
  TXCenterDraft = 'TXCenterDraft',
}

export enum ENOPDonorType {
  DBD = 'DBD',
  DCD = 'DCD',
}

export enum ENOPSourceType {
  OPO = 'OPO',
  TxCenter = 'TX Center',
}

export enum ENOPRoutePlanStatus {
  RoutePlanningStart = 'RoutePlanning',
  WaitingForAviationApproval = 'WaitingForAviationApproval',
  WaitingForQuoteApproval = 'WaitingForQuoteApproval',
  RoutePlanningDone = 'RoutePlanningDone',
  PendingResourcesBooking = 'PendingResourcesBooking',
  ResourcesBooked = 'ResourcesBooked',
}

export enum ENOPQuoteStatus {
  NoQuote = 'NoQuote',
  Created = 'Created',
  Rejected = 'Rejected',
  ApprovedInternally = 'ApprovedInternally',
  Approved = 'Approved',
  RejectedInternally = 'RejectedInternally',
  SentToTXCenter = 'SentToTxCenter',
  ApprovedByTXCenter = 'ApprovedByTxCenter',
  RejectedByTXCenter = 'RejectedByTxCenter',
  InvoiceSent = 'InvoiceSent',
  InvoicePaid = 'InvoicePaid',
}

export enum ENOPCaseTransportType {
  Ground = 'Ground',
  Avia = 'Avia',
}

export enum ENOPServiceType {
  NopWithTmdxSurgeon = 'NopWithTmdxSurgeon',
  NopWithoutTmdxSurgeon = 'NopWithoutTmdxSurgeon',
  None = 'None',
  DirectAcquisition = 'DirectAcquisition',
}

export enum ENOPLogisticsProviderType {
  None = 'None',
  TMDX = 'TMDX',
  PartnerProvider = 'PartnerProvider',
  TXCenterProvider = 'TXCenterProvider',
}

export enum ENOPAcceptanceCriteriaBiopsy {
  Yes = 'Yes',
  BasedOnVisual = 'BasedOnVisual',
}

export enum ENOPAcceptanceCriteriaWarmIschemicTimeType {
  SystolicLessThan80 = 'SystolicLessThan80',
  SystolicLessThan50 = 'SystolicLessThan50',
  MapLessThan50 = 'MapLessThan50',
  SystolicLessThan80SaturationLessThan80 = 'SystolicLessThan80SaturationLessThan80',
}

export enum ENOPDeclineType {
  Aborted = 'Aborted',
  DryRun = 'DryRun',
  Turndown = 'Turndown',
  Transplant = 'Transplant',
}

export enum ENOPDispositionType {
  CaseNotAcceptedForOCS = 'CaseNotAcceptedForOCS',
  CaseCancelledByTMDX = 'CaseCancelledByTMDX',
  CaseCancelledByTXC = 'CaseCancelledByTXC',
  DCDDonorDidNotExpire = 'DCDDonorDidNotExpire',
  Turndown = 'Turndown',
  NotTransplanted = 'NotTransplanted',
}

export enum ENOPDispositionReasonType {
  NoClinicalSpecialists = 'NoClinicalSpecialists',
  NoSurgeon = 'NoSurgeon',
  NoPlanes = 'NoPlanes',
  NoGroundTransport = 'NoGroundTransport',
  TooShortNotice = 'TooShortNotice',
  ByTxCenter = 'ByTxCenter',
  DonationWithdrawnByOPO = 'DonationWithdrawnByOPO',
  OCSContraindicationOrNotSuitable = 'OCSContraindicationOrNotSuitable',
  DonorDidNotProgressToDeathWithinEstablishedTimeframe = 'DonorDidNotProgressToDeathWithinEstablishedTimeframe',
  OCSContraindication = 'OCSContraindication',
  DeviceMalfunction = 'DeviceMalfunction',
  ClinicallyDeemedUnacceptableForTransplantation = 'ClinicallyDeemedUnacceptableForTransplantation',
  // Reasons for lungs, but we just use general options above
  // DeclinedDueToDonorFactors = 'DeclinedDueToDonorFactors',
  // DeclinedDueToRecipientFactors = 'DeclinedDueToRecipientFactors',
  // DeclinedDueToFailureOfTheOPOToAllocateTheOrgan = 'DeclinedDueToFailureOfTheOPOToAllocateTheOrgan',
  // DeclinedDueToLogisticsReason = 'DeclinedDueToLogisticsReason',
  // DeclinedDueToUnrepairableSurgicalInjury = 'DeclinedDueToUnrepairableSurgicalInjury',
  // DeclinedDueToMissedAPreExistingInternalAirLeak = 'DeclinedDueToMissedAPreExistingInternalAirLeak',
}

export enum ENOPDispositionSpecificationType {
  None = 'None',
  DonorReasons = 'DonorReasons',
  RecipientReasons = 'RecipientReasons',
  LogisticsCosts = 'LogisticsCosts',
  AcceptedAlternateDonor = 'AcceptedAlternateDonor',
  ChangedToAnAlternatePreservationMethod = 'ChangedToAnAlternatePreservationMethod',
  DonorQuality = 'DonorQuality',
  OrganNotViable = 'OrganNotViable',
  LogisticalIssues = 'LogisticalIssues',
  TXCenterAcceptanceCriteria = 'TXCenterAcceptanceCriteria',
}

export enum ENOPTurndownOutcome {
  DiscardOrgan = 'DiscardOrgan',
  ShipOrgan = 'ShipOrgan',
  RellocateOrgan = 'RellocateOrgan',
}

export enum ENOPCaseLogEventType {
  CaseDraftCreated = 'CaseDraftCreated',
  CaseTxCenterDraftCreated = 'CaseTxCenterDraftCreated',
  CaseDetailsUpdated = 'CaseDetailsUpdated',
  CaseCreated = 'CaseCreated',
  CaseDraftDeleted = 'CaseDraftDeleted',
  CaseStatusUpdated = 'CaseStatusUpdated',
  CaseRouteAdded = 'CaseRouteAdded',
  CaseResourceReserved = 'CaseResourceReserved',
  CaseResourceReleased = 'CaseResourceReleased',
  CaseResourceAssigned = 'CaseResourceAssigned',
  CaseResourceReassigned = 'CaseResourceReassigned',
  CaseResourceUnassigned = 'CaseResourceUnassigned',
  CaseResourceInvitationAccepted = 'CaseResourceInvitationAccepted',
  CaseResourceInvitationDeclined = 'CaseResourceInvitationDeclined',
  ResourceStatusUpdated = 'ResourceStatusUpdated',
  CaseQuoteRedacted = 'CaseQuoteRedacted',
  DonorORTimeDelayAdded = 'DonorORTimeDelayAdded',
  DonorORTimeDelayUpdated = 'DonorORTimeDelayUpdated',
  CaseNoteAdded = 'CaseNoteAdded',
  CaseNoteRemoved = 'CaseNoteRemoved',
  CaseNoteUpdated = 'CaseNoteUpdated',
  CustomerFeedbackAdded = 'CustomerFeedbackAdded',
  InvoiceCreated = 'InvoiceCreated',
  OrganAcceptanceCriteriaUpdated = 'OrganAcceptanceCriteriaUpdated',
  ReAllocatedCaseCreated = 'ReAllocatedCaseCreated',
  ReAllocatedCaseUpdated = 'ReAllocatedCaseUpdated',
  ReAllocatedCaseRemoved = 'ReAllocatedCaseRemoved',
  AttachFiles = 'AttachFiles',
  DetachFile = 'DetachFile',
  CaseReviewUpdated = 'CaseReviewUpdated',
  CaseQuoteCommentSet = 'CaseQuoteCommentSet',
  CaseQuoteCreated = 'CaseQuoteCreated',
  CaseQuoteUpdated = 'CaseQuoteUpdated',
  CaseQuoteRejectedInternally = 'CaseQuoteRejectedInternally',
  CaseQuoteApprovedInternally = 'CaseQuoteApprovedInternally',
  CaseQuoteSentToTxCenter = 'CaseQuoteSentToTxCenter',
  CaseQuoteRejectedByTxCenter = 'CaseQuoteRejectedByTxCenter',
  CaseQuoteApprovedByTxCenter = 'CaseQuoteApprovedByTxCenter',
  CustomRouteInitiated = 'CustomRouteInitiated',
  RoutePlanningStatusUpdated = 'RoutePlanningStatusUpdated',
  CaseResourceLogisticsStatusUpdated = 'CaseResourceLogisticsStatusUpdated',
  CaseRouteUpdated = 'CaseRouteUpdated',
  CaseRouteInitiated = 'CaseRouteInitiated',
  CaseDeclined = 'CaseDeclined',
  ServiceDeclined = 'ServiceDeclined',
  OpoContactsAssigned = 'OpoContactsAssigned',
  OpoContactIsPrimaryChanged = 'OpoContactIsPrimaryChanged',
  OpoContactsUnassigned = 'OpoContactsUnassigned',
  CaseResourceStartTimeEstablished = 'CaseResourceStartTimeEstablished',
  CaseLinkAdded = 'CaseLinkAdded',
  CaseLinkUpdated = 'CaseLinkUpdated',
  CaseLinkRemoved = 'CaseLinkRemoved',
  RequestOrganApproval = 'RequestOrganApproval',
  OrganApproved = 'OrganApproved',
  OrganDeclined = 'OrganDeclined',
  CreateSurgeonCaseSummary = 'CreateSurgeonCaseSummary',
  CaseInvoiceCreated = 'CaseInvoiceCreated',
}

export enum ENOPCaseLogGroup {
  CaseFeedback = 'CaseFeedback',
  CaseLogistics = 'CaseLogistics',
  CaseManagement = 'CaseManagement',
  CaseUpdate = 'CaseUpdate',
  FinancialManagement = 'FinancialManagement',
  ResourceManagement = 'ResourceManagement',
  Unknown = 'Unknown', // Client only
}

export enum ENOPRoutePlanningStatus {
  None = 'None',
  RoutePlanning = 'RoutePlanning',
  WaitingForAviationApproval = 'WaitingForAviationApproval',
  WaitingForQuoteApproval = 'WaitingForQuoteApproval',
  RoutePlanningDone = 'RoutePlanningDone',
  PendingResourcesBooking = 'PendingResourcesBooking',
  ResourcesBooked = 'ResourcesBooked',
}

export enum ENOPResourceLogisticsStatus {
  None = 'None',
  Reserved = 'Reserved',
  BookingSent = 'BookingSent',
  Booked = 'Booked',
  DeployedToDonorHospital = 'DeployedToDonorHospital',
  AtDonorHospital = 'AtDonorHospital',
  RecoveryIsCompleted = 'RecoveryIsCompleted',
  DeployedFromDonorHospital = 'DeployedFromDonorHospital',
  AtTXCenter = 'AtTXCenter',
  DeployedToHub = 'DeployedToHub',
  DeployedFromTXCenter = 'DeployedFromTXCenter',
  OCSDeployed = 'OCSDeployed',
  OCSDone = 'OCSDone',
  Done = 'Done',
  BookedInMao = 'BookedInMao',
  CancelledInMao = 'CancelledInMao',
}

export enum ENOPQuoteRejectReason {
  NotSuitable = 'NotSuitable',
  FullOwnLogistics = 'FullOwnLogistics',
  OwnAirLogistics = 'OwnAirLogistics',
  OwnGroundLogistics = 'OwnGroundLogistics',
}

export enum ENOPSurgeonCaseSummaryStatus {
  Incomplete = 'Incomplete',
  Completed = 'Completed',
}

export enum ENOPLiverQuality {
  NoQualityIssues = 'NoQualityIssues',
  Congested = 'Congested',
  Steatotic = 'Steatotic',
  Cirrhotic = 'Cirrhotic',
  CalcifiedVessels = 'CalcifiedVessels',
  Other = 'Other',
}

export enum ENOPFlushType {
  Good = 'Good',
  DidNotFlushWell = 'DidNotFlushWell',
}

export enum ENOPLiverOutcome {
  PlacedOnOCSLiver = 'PlacedOnOCSLiver',
  NotPlacedOnOCSLiver = 'NotPlacedOnOCSLiver',
  DCDNotPlacedOnOCSLiver = 'DCDNotPlacedOnOCSLiver',
}

export enum ENOPAberrantAnatomyType {
  ReplacedRightOrAccessoryRightHepaticArtery = 'ReplacedRightOrAccessoryRightHepaticArtery',
  ReplacedLeftOrAccessoryLeftHepaticArtery = 'ReplacedLeftOrAccessoryLeftHepaticArtery',
  Other = 'Other',
}

export enum ENOPProcurementEnjuryType {
  ArterialInjury = 'ArterialInjury',
  BiliaryInjury = 'BiliaryInjury',
  PortalVeinInjury = 'PortalVeinInjury',
  ParenchymalInjury = 'ParenchymalInjury',
  Other = 'Other',
}

export enum ENOPBacktableInjuryType {
  ArterialInjury = 'ArterialInjury',
  BiliaryInjury = 'BiliaryInjury',
  VenousInjury = 'VenousInjury',
}

export enum ENOPNoLiverInjuryType {
  IntestinalPerforationWithContamination = 'IntestinalPerforationWithContamination',
  KidneyInjury = 'KidneyInjury',
  PancreasInjury = 'PancreasInjury',
  Other = 'Other',
}

export enum ENOPImpactOfInjuryType {
  NoImpact = 'NoImpact',
  OrganUsedButInjuryChangedAllocationOrResultedInAlterationToPractice = 'OrganUsedButInjuryChangedAllocationOrResultedInAlterationToPractice',
  OrganDeclined = 'OrganDeclined',
}

export enum ENOPAssistanceType {
  TrainedProcurementSurgeon = 'TrainedProcurementSurgeon',
  TrainedSurgicalAssistant = 'TrainedSurgicalAssistant',
  SurgicalResidentOrFellow = 'SurgicalResidentOrFellow',
  UnspecializedSurgicalAssistant = 'UnspecializedSurgicalAssistant',
  None = 'None',
}

export enum ENOPOrganApprovalStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Declined = 'Declined',
}

export enum ENOPOrganOnOCSDeclineReason {
  DonorQuality = 'DonorQuality',
  OrganNotViable = 'OrganNotViable',
  RecipientReasons = 'RecipientReasons',
  LogisticalIssues = 'LogisticalIssues',
  TXCenterAcceptanceCriteria = 'TXCenterAcceptanceCriteria',
  AlternatePreservationMethod = 'AlternatePreservationMethod',
}

export enum ENOPQuoteDeclineReason {
  NotSuitable = 'NotSuitable',
  FullOwnLogistics = 'FullOwnLogistics',
  OwnAirLogistics = 'OwnAirLogistics',
  OwnGroundLogistics = 'OwnGroundLogistics',
}

export enum ENOPReviewStatus {
  Approved = 'Approved',
  Rejected = 'Rejected',
}
export enum ENOPReviewType {
  Quote = 'Quote',
  Aviation = 'Aviation',
  Ground = 'Ground',
  TXCenterQuote = 'TXCenterQuote',
}
